import React from 'react'
import PropTypes from 'prop-types'

import PlayerRoles from '../playerRoles'

export default function SingleFantasyLeague({ styles, data, indexJ, type, teamAID }) {
  const totalCredits = 100
  const credits = data?.aSelectedPlayerFan?.reduce((acc, credit) => data?.oTPFan?._id !== credit._id && acc + credit.nRating, 0)
  return (
    <>
      <div className={`${styles.teamBlock} w-100 flex-shrink-0 position-relative`}>
        <div className={`${styles.info} d-flex justify-content-between position-absolute align-item-center`}>
          <div className="mb-0 w-25 d-flex flex-column flex-md-row text-start">
            <span className="small-text">{'Players'}</span>
            <p className="ms-md-2 font-semi mb-0">
              {data?.aSelectedPlayerFan?.length}/{type === 'ew' ? 12 : 11}
            </p>
          </div>
          <div className="mb-0 d-flex flex-grow-1 justify-content-center">
            <div className={`${styles.teamDetails} d-flex`}>
              <div
                className={`${styles.name} ${
                  teamAID === data?.oTeam?._id ? styles.nameDark : ''
                } ps-1 pe-1 ps-sm-2 pe-sm-2 rounded-4 mt-0 px-2 mx-1 mx-md-2 d-flex`}>
                {data?.oTeamA?.oTeam?.sAbbr || data?.oTeamA?.oTeam?.sTitle}
              </div>
              <p className="flex-shrink-0 ms-2 me-2 ms-sm-3 me-sm-3 mb-0">
                {data?.oTeamA?.nCount} : {data?.oTeamB?.nCount}
              </p>
              <div
                className={`${styles.name} ${styles.nameDark} ps-1 pe-1 ps-sm-2 pe-sm-2 rounded-4 mt-0 px-2 mx-1 mx-md-2 d-flex align-items-center`}>
                {data?.oTeamB?.oTeam?.sAbbr || data?.oTeamB?.oTeam?.sTitle}
              </div>
            </div>
          </div>
          <div className="mb-0 w-25 d-flex flex-column flex-md-row ">
            <p className="mb-0 small-text text-end">{'Credits Left'}</p>
            <p className="ms-md-2 font-semi mb-0 text-end">{totalCredits - credits}/100</p>
          </div>
        </div>
        <div className={`${styles.team} d-flex align-items-center justify-content-center`}>
          <div className={`${styles.teamContainer} d-flex flex-column align-items-center justify-content-center w-100`}>
            <label className={`${styles.label} xsmall-text text-uppercase my-1 mt-sm-1`}>{'Wicket Keeper'}</label>
            <div className={`${styles.playerList} d-flex justify-content-center w-100 flex-wrap text-center mt-2`}>
              {data?.aSelectedPlayerFan?.map((player, index) => {
                return (
                  (player?.eRole === 'wk' || player?.eRole === 'wkbat') && (
                    <PlayerRoles styles={styles} key={index} data={player} capData={data} teamA={teamAID} />
                  )
                )
              })}
            </div>
            <label className={`${styles.label} xsmall-text text-uppercase mb-1 mt-sm-1`}>{'Batter'}</label>
            <div className={`${styles.playerList} d-flex justify-content-center w-100 flex-wrap text-center mt-2`}>
              {data?.aSelectedPlayerFan?.map((player, index) => {
                return player?.eRole === 'bat' && <PlayerRoles styles={styles} key={index} data={player} capData={data} teamA={teamAID} />
              })}
            </div>
            <label className={`${styles.label} xsmall-text text-uppercase mb-1 mt-sm-1`}>{'All Rounder'}</label>
            <div className={`${styles.playerList} d-flex justify-content-center w-100 flex-wrap text-center mt-2`}>
              {data?.aSelectedPlayerFan?.map((player, index) => {
                return player?.eRole === 'all' && <PlayerRoles styles={styles} key={index} data={player} capData={data} teamA={teamAID} />
              })}
            </div>
            <label className={`${styles.label} xsmall-text text-uppercase mb-1 mt-sm-1`}>{'Bowler'}</label>
            <div className={`${styles.playerList} d-flex justify-content-center w-100 flex-wrap text-center mt-2`}>
              {data?.aSelectedPlayerFan?.map((player, index) => {
                return player?.eRole === 'bowl' && <PlayerRoles styles={styles} key={index} data={player} capData={data} teamA={teamAID} />
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

SingleFantasyLeague.propTypes = {
  styles: PropTypes.any,
  data: PropTypes.object,
  indexJ: PropTypes.number,
  playerData: PropTypes.array,
  type: PropTypes.string,
  teamAID: PropTypes.string
}
